export default "__VITE_PUBLIC_ASSET__34022820__"